import { environment } from "environment/environment";

export const ExecutionRiskApiUrl = {
  baseUrl: environment.executionRiskApiBaseUrl,
  create: environment.executionRiskSaveUrl,
  getAll: environment.executionRiskGetAllUrl,
  getByIdAndUser: environment.executionRiskGetByIdUrl,
  update: environment.executionRiskUpdateUrl,
  delete: environment.executionRiskDeleteUrl,
};
